const notificationCenter = {
  pageTitle: "Notification center",
  loading: "Loading notifications",
  tabs: {
    reporting: "Reporting",
    reportingCalendar: "Reporting calendar",
    messages: "Messages",
    registrationTracker: "Registration tracker",
    thresholds: "Thresholds",
    cases: "Cases",
    chargeInvoices: "Charge invoices",
    fundRequests: "Request of Funds",
    intermediaryPayments: "Intermediary payments",
    product: "Product",
    invoices: "Invoices",
    transactions: "Transactions",
    consumption: "Consumption",
    billing: "Billing",
    settings: "Settings",
    registrations: "Registrations",
    deadlines: "Deadlines",
  },
  sections: {
    reporting: {
      main: "Reporting",
    },
    reportingCalendar: {
      main: "Reporting calendar",
    },
    messages: {
      main: "Messages",
    },
    registrationTracker: {
      main: "Registration tracker",
    },
    thresholds: {
      main: "Thresholds",
    },
    cases: {
      main: "Cases",
    },
    chargeInvoices: {
      main: "Charge invoices",
    },
    fundRequests: {
      main: "Request of Funds",
    },
    intermediaryPayments: {
      main: "Intermediary payments",
    },
    product: {
      main: "Product",
    },
    invoices: {
      main: "Invoices",
    },
    transactions: {
      main: "Transactions",
    },
    consumption: {
      main: "Consumption",
    },
    billing: {
      main: "Billing",
    },
    settings: {
      main: "Settings",
    },
    registrations: {
      main: "Registrations",
    },
    deadlines: {
      main: "Deadlines",
    },
  },
  columns: {
    company: "Company",
    created: "Created",
    number: "Number",
    requested: "Requested",
    received: "Received",
    balance: "Balance",
    period: "Period",
    countryJurisdiction: "Country/Jurisdiction",
    typeOfReport: "Type of report",
    dueDate: "Due date",
    type: "Type",
    subject: "Subject",
    status: "Status",
    documents: "Documents",
    dateLastStatusChanged: "Date last status\nchanged",
    generatedBy: "Generated by",
    app: "App",
    typeOfSubscription: "Type of subscription",
    typeOfLimit: "Type of limit",
    limit: "Limit",
    source: "Source",
    description: "Description",
    amount: "Amount",
    payer: "Payer",
    typeOfNumber: "Type of number",
    typeOfInvoice: "Type of invoice",
    counterparty: "Counterparty",
    jurisdiction: "Jurisdiction",
    date: "Date",
    companiesList: "Companies list",
    orderDate: "Order date",
    category: "Category",
    estimatedRegistrationDate: "Estimated date of\nregistration",
    lastUpdated: "Last updated",
    filingDate: "Filing date",
    comments: "Comments",
    comment: "Comment",
    registrator: "Registrator",
    typeOfRegistration: "Type of registration",
    subcategoryOfRegistration: "Subcategory of\nregistration",
    estimateDateOfRegistration: "Estimate date of\nregistration",
    percentReached: "% reached",
    dateWhen100Reached: "Date when 100%\nreached",
    actions: "Actions",
    intermediaryPaymentEvent: "Event",
    intermediaryPaymentRecipient: "Recipient",
    intermediaryPaymentStep: "Next step",
    intermediaryPaymentStatus: "Status",
  },
  intermediaryPayments: {
    summary: {
      urgent: "Urgent",
      unreadLine: "{{count}} unread",
    },
    reason: {
      approvalRequired: "Payment approval required",
      revisionRequired: "Payment returned for revision",
      readyToTake: "Payment approved — you can take it",
      executionInProgress: "Payment is in your queue — complete the transfer",
      creditCheckRequired: "Transfer completed — credit check required",
      closeRequired: "Transfer completed — close the payment",
      paymentError: "Payment error — action required",
      correctionAvailable: "Payment error — correct the details",
      outcomeUnknown: "Payment outcome unknown — clarify the result",
      approved: "Payment approved ({{actor}})",
      rejected: "Payment rejected",
      taken: "{{actor}} took the payment",
      takenOver: "{{actor}} took over the payment",
      executorReturned: "Executor returned the payment for revision",
      transferred: "Transfer completed",
      outcomeResolved: "Payment outcome clarified",
      paymentReturned: "Payment was returned",
      cancelled: "Payment cancelled",
      closed: "Payment closed",
      fallback: "Payment update",
    },
    requiredStep: {
      submission: "Submission",
      approval: "Approval",
      revision: "Revision",
      take: "Take",
      execution: "Execution",
      outcomeResolution: "Outcome resolution",
      correction: "Correction",
      creditCheck: "Credit check",
      close: "Close",
      completed: "Completed",
    },
    nextExpected: {
      owner: "Owner",
      executor: "Executor",
      initiator: "Initiator",
    },
    roles: {
      owner: "Owner",
      executor: "Executor",
      initiator: "Initiator",
    },
    nextStep: {
      roleApproval: "{{role}} approval",
      submission: "Submission",
      ownerApproval: "Owner approval",
      initiatorRevision: "Initiator revision",
      takePayment: "Take payment",
      executePayment: "Execute payment",
      creditCheck: "Credit check",
      resolveOutcome: "Resolve outcome",
      reviewPaymentError: "Review payment error",
      closePayment: "Close payment",
      completed: "Completed",
      fallback: "Action required",
    },
    step: {
      next: "Next: {{role}}",
      yourRole: "Your role: {{roles}}",
    },
    priority: {
      critical: "Critical",
      overdue: "Overdue",
    },
    inactive: {
      resolved: "Resolved",
      noLongerRelevant: "No longer relevant",
    },
  },
  actions: {
    open: "Open",
    openRequest: "Open request",
    openInNewTab: "Open in new tab",
    openBillingHistory: "Open in Billing history",
    openPaymentsList: "Open payments list",
    markAsRead: "Mark as read",
    markAllAsRead: "Mark all as read",
    seen: "Seen",
    viewDocumentRequestDetails: "View details",
    viewRegistrationDetails: "View details",
    addComment: "Add comment",
    changeStatus: "Change status",
    delete: "Delete",
    markRequiresAttention: "Mark as requires attention",
    removeAttentionFlag: "Remove attention flag",
    reviewPayment: "Review payment",
    take: "Take",
  },
  intermediaryPaymentsSummary: {
    reference: "Reference",
    amount: "Amount",
    recipient: "Recipient",
  },
  intermediaryPaymentsAction: {
    companySwitchFailed:
      "Could not switch to the payment company. Try opening the payment from the list.",
    paymentNotFound: "Payment not found.",
  },
  intermediaryPaymentsReview: {
    title: "Review payment · {{reference}}",
    paymentAmount: "Payment amount",
    purpose: "Purpose of payment",
    relatedRequest: "Related request",
    commentHint: "Optional for approval, required for return or reject.",
    takeAction: "Take action",
    sections: {
      paymentDetails: "Payment details",
      workflow: "Workflow & status",
      supportingDocuments: "Supporting documents",
      decision: "Decision",
    },
    staleChanged:
      "This payment has changed since this notification was loaded. Refresh the notification to continue.",
    staleActionUnavailable:
      "This action is no longer available for this payment. Refresh the notification to continue.",
    detailsUnavailable:
      "Full payment details could not be loaded, so this decision can't be confirmed here. Close the drawer and try again, or use Open in new tab to review the payment.",
  },
  changeStatusModal: {
    title: "Change status",
    status: "Status",
    placeholder: "Select status",
    cancel: "Cancel",
    confirm: "Save",
  },
  documentRequestDrawer: {
    title: "Document request details",
    subject: "Subject",
    requestedOn: "Requested on",
    requestedBy: "Requested by",
    uploadedDocuments: "Uploaded documents ({{count}})",
    noDocuments: "No documents uploaded yet",
    openDocument: "Open document",
  },
  documents: {
    uploadedCount: "{{count}} uploaded",
    underReview: "Under review",
    awaitingDocuments: "Awaiting documents",
  },
  filters: {
    visibility: {
      mine: "Show mine",
      all: "Show all",
    },
    deadlinesPrefix: "Deadlines:",
    deadlines: {
      next3Days: "Next 3 days",
      forthcoming: "Forthcoming",
      all: "All",
      missed: "Missed",
    },
    declarationTypePrefix: "Type of report:",
    declarationType: {
      all: "All",
      declaration: "VAT declarations",
      salesTaxReturn: "Sales Tax",
      eprReport: "EPR",
    },
    registrations: {
      company: "Company",
      companyPrefix: "Company:",
      allCompanies: "All companies",
      orderDate: "Order date",
      orderDatePrefix: "Order date:",
      jurisdiction: "Country / Jurisdiction",
      jurisdictionPrefix: "Jurisdiction:",
      allJurisdictions: "All jurisdictions",
      typeOfRegistration: "Type of registration",
      typeOfRegistrationPrefix: "Type of registration:",
      allTypesOfRegistration: "All types",
      subcategory: "Subcategory of registration",
      subcategoryPrefix: "Subcategory:",
      allSubcategories: "All subcategories",
      status: "Status",
      statusPrefix: "Status:",
      allStatuses: "All statuses",
      dateLastStatusChanged: "Date last status changed",
      dateLastStatusChangedPrefix: "Date last status changed:",
      registrator: "Registrator",
      registratorPrefix: "Registrator:",
      allRegistrators: "All registrators",
      estimatedRegistrationDate: "Estimate date of registration",
      estimatedRegistrationDatePrefix: "Estimate date of registration:",
      newestFirst: "Newest first",
      oldestFirst: "Oldest first",
      clearSort: "Clear",
      sort: "Sort",
    },
    intermediaryPayments: {
      actionRequiredPrefix: "Show:",
      actionRequired: "Action required",
      actionRequiredActive: "Action required",
      actionRequiredHistory: "History",
      actionRequiredAll: "All",
      isReadPrefix: "Read state:",
      isRead: "Read state",
      isReadAll: "All",
      isReadUnread: "Unread",
    },
  },
  statuses: {
    info: "Info",
    approved: "Approved",
    pending: "Pending",
    underReview: "Under review",
    voided: "Voided",
    new: "New",
    declined: "Declined",
    rejected: "Rejected",
    submitted: "Submitted",
    closed: "Closed",
    uploaded: "Uploaded",
    actionRequired: "Action required",
    answered: "Answered",
    error: "Error",
    active: "Active",
    inactive: "Inactive",
    awaitingFunds: "Awaiting funds",
    partiallyReceived: "Partially received",
    fullyReceived: "Fully received",
  },
  registrationStatuses: {
    awaiting_documents: "Awaiting Documents",
    waiting_information_details: "Waiting information/details",
    awaiting_payment_from_client: "Awaiting payment from the client",
    documentation_received: "Documentation Received",
    under_internal_review: "Under Internal Review",
    ready_for_filing: "Ready for Filing",
    filed: "Filed",
    in_government_review: "In Government Review",
    registration_issued: "Registration Issued",
    rejected: "Rejected",
    registration_canceled: "Registration canceled",
    abandoned: "Abandoned",
    on_hold: "On Hold",
    correction_required: "Correction Required",
    office_action_issued: "Office Action Issued",
    response_filed: "Response Filed",
    awaiting_third_party_consent: "Awaiting Third-Party Consent",
    opposition_period: "Opposition Period",
    approved: "Approved",
    awaiting_original_documents: "Awaiting Original Documents",
    completed: "Completed",
    withdrawn: "Withdrawn",
    expired: "Expired",
  },
  empty: {
    title: "No notifications",
    description: "There are no items in this section.",
    tabPlaceholder: "This section will be available soon.",
    noTablesForRole: "No notification sections are available for your account.",
  },
};

export default notificationCenter;
